<script setup lang="ts">
import { PropType } from 'vue'
import type { TravelInfoTitleSection } from './../../types'
import { getCurrentCulture } from './../../utilities/culture-helper'

defineProps({
  titleInfo: {
    type: Object as PropType<TravelInfoTitleSection>,
    required: true,
  },
})

const { cultureShortCode } = getCurrentCulture()
</script>

<template>
  <div class="status-card-set__title">
    {{ titleInfo.title[cultureShortCode] }}
  </div>
  <div
    v-if="
      titleInfo.delayInfo.isVisible &&
      titleInfo.delayInfo.message[cultureShortCode]
    "
    class="status-card-set__message"
  >
    {{ titleInfo.delayInfo.message[cultureShortCode] }}
  </div>
  <div
    v-if="
      titleInfo.serviceInfo.isVisible &&
      titleInfo.serviceInfo.message &&
      titleInfo.serviceInfo.message[cultureShortCode]?.length > 0
    "
    class="status-card-set__status"
  >
    {{ titleInfo.serviceInfo.message![cultureShortCode] }}
  </div>
</template>

<style lang="scss" scoped></style>
